<template>
  <div>
    <div class="d-none d-md-block">
      <labeled-form-control label="Name">
        <div class="row">
          <div class="col-6">
            <input
              v-model="clientFirstName"
              class="form-control"
              type="text"
              name="name"
              placeholder="Enter First Name"
              ref="firstNameField"
              maxlength="99"
              @focus="handleFocus('firstName')"
              @blur="handleBlur"
            />
            <validation-message v-if="validator.firstName" :message="validator.firstName"/>
          </div>
          <div class="col-6">
            <input
              v-model="clientLastName"
              class="form-control"
              type="text"
              name="name"
              placeholder="Enter Last Name"
              maxlength="99"
              @focus="handleFocus('lastName')"
              @blur="handleBlur"
            />
            <validation-message v-if="validator.lastName" :message="validator.lastName"/>
          </div>
        </div>
      </labeled-form-control>
    </div>

    <div class="d-block d-md-none">
      <labeled-form-control label="First Name">
        <div class="row">
          <div class="col-12">
            <input
              v-model="clientFirstName"
              class="form-control"
              type="text"
              name="name"
              placeholder="Enter First Name"
              ref="firstNameField"
              maxlength="99"
              @focus="handleFocus('firstName')"
              @blur="handleBlur"
            />
            <validation-message v-if="validator.firstName" :message="validator.firstName"/>
          </div>
        </div>
      </labeled-form-control>

      <labeled-form-control label="Last Name">
        <div class="row">
          <div class="col-12">
            <input
              v-model="clientLastName"
              class="form-control"
              type="text"
              name="name"
              placeholder="Enter Last Name"
              maxlength="99"
              @focus="handleFocus('lastName')"
              @blur="handleBlur"
            />
            <validation-message v-if="validator.lastName" :message="validator.lastName"/>
          </div>
        </div>
      </labeled-form-control>
    </div>
  </div>
</template>

<script>
import process from 'process'
import { mapGetters, mapMutations, mapState } from 'vuex'
import { ClientHelper } from '@/helpers/ClientHelper'
import { StatusEmitterMixin } from '@/mixins/GeneralRegistration/StatusEmitterMixin'
import LabeledFormControl from '@/components/Layout/LabeledFormControl.vue'
import ValidationMessage from '@/components/ErrorValidation/ValidationMessage.vue'

export default {
  name: 'ClientNameFields',
  mixins: [StatusEmitterMixin],
  data () {
    return {
      validator: ClientHelper.getClientValidator(),
      requiredFocused: {
        firstName: false,
        lastName: false
      }
    }
  },
  computed: {
    ...mapState('ApplicationEvents', [
      'saveClientRegistrationEvent'
    ]),
    ...mapGetters('ClientRegistrationUpload', [
      'clientModel'
    ]),
    clientFirstName: {
      get () {
        return this.clientModel.firstName
      },
      set (value) {
        this.setFirstName(value)
      }
    },
    clientLastName: {
      get () {
        return this.clientModel.lastName
      },
      set (value) {
        this.setLastName(value)
      }
    },
    allRequiredFocused () {
      return this.requiredFocused.firstName && this.requiredFocused.lastName
    },
    validated () {
      return !!this.validator.isValid
    }
  },
  watch: {
    saveClientRegistrationEvent () {
      this.validate()
    }
  },
  methods: {
    ...mapMutations('ClientRegistrationUpload', [
      'setFirstName',
      'setLastName'
    ]),
    handleFocus (field) {
      if (field in this.requiredFocused) {
        this.requiredFocused[field] = true
      }
    },
    handleBlur () {
      if (this.allRequiredFocused) {
        this.validate()
      }
    },
    validate () {
      this.validator.check(this.clientModel)
    }
  },
  mounted () {
    process.nextTick(() => this.$refs.firstNameField.focus())
  },
  components: {
    'labeled-form-control': LabeledFormControl,
    'validation-message': ValidationMessage
  }
}
</script>
